module.exports = __webpack_public_path__ + "img/m.5161bb58.svg";